<div
  class="cm-loader"
  [ngClass]="{
    'cm-loader-absolute': absolute
  }"
>
  <div class="cm-loader-spinner"></div>
  <span class="sr-only">{{ 'shared.common.loading' | translate }}</span>
</div>
